<template>
  <v-dialog v-model="dialog" scrollable max-width="500">
    <v-card>
      <v-card-title>
        スタッフ等級編集
        <v-spacer />
        <IconButton icon="mdi-close" @click="cancel" />
      </v-card-title>

      <v-card-text>
        <v-form ref="grade_form">
          <v-container>
            <v-row>
              <v-col>
                <v-select
                  label="等級"
                  v-model="grade"
                  item-text="label"
                  item-value="value"
                  :items="gradeItems"
                  :rules="gradeRules"
                  return-object
                  outlined
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <DatePicker v-model="gradeJoinDate" label="着任日" />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <Button @click="erntry_confirm" color="primary">登録</Button>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <ConfirmDialog
          ref="confirm"
          title="等級情報編集"
          :message="confirmMessage"
          buttonMessage="OK"
          @confirm="editUserGradeInfo"
        >
        </ConfirmDialog>

        <DialogMessage ref="dialog" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import moment from 'moment';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import {
  getSessionStorageItem,
  chackDateFormatStr,
  makeDateFormatStr,
} from '../../../common.js';
export default {
  components: {
    ConfirmDialog,
  },
  data: () => ({
    dialog: false,
    confirm: false,
    entryFlg: false,
    confirmMessage: null,
    resolve: null,
    reject: null,

    userGradeId: null,
    userId: null,
    organaizationKey: null,
    gradeId: null,
    gradeJoinDate: null,
    gradeLeaveDate: null,
    gradeValidFlg: null,
    createdAt: null,
    updateAt: null,

    latestGradeJoinDate: '',

    grade: { label: '', value: '' },
    gradeRules: [(v) => !!v || '必須選択入力項目です'],
    gradeItems: [],
    items: [],
  }),

  methods: {
    open(item, organaizationKey, userId, latestGradeJoinDate) {
      this.dialog = true;

      // 等級情報の設定
      this.getGrade();

      // 共通
      this.organaizationKey = organaizationKey;
      this.userId = userId;
      this.latestGradeJoinDate = latestGradeJoinDate;

      // 等級設定
      if (item == null) {
        this.entryFlg = true;
        this.grade = { label: '', value: '' };
        this.gradeJoinDate = moment().format('YYYY-MM-DD');
        this.gradeLeaveDate = null;
        this.gradeValidFlg = config.VALID_FLAG_ON;
        this.createdAt = null;
        this.updateAt = null;
      } else {
        this.entryFlg = false;
        this.grade.value = item.GRADE_ID;
        this.gradeJoinDate = item.GRADE_JOIN_DATE;
        this.gradeLeaveDate = item.GRADE_LEAVE_DATE;
        this.gradeValidFlg = item.GRADE_VALID_FLG;
        this.createdAt = item.CREATED_AT;
        this.updateAt = item.UPDATED_AT;
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    async getGrade() {
      this.loading = true;

      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      let vm = this;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/grade/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 等級データ取得
          vm.items = response.data;
          for (let i = 0; i < vm.items.length; i++) {
            if (vm.items[i].EXPIRATION == config.USE_IN) {
              var item = {
                label: vm.items[i].GRADE_NAME,
                value: vm.items[i].GRADE_ID,
              };
              this.gradeItems.push(item);
            }
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
    erntry_confirm() {
      // 入力チェック
      if (!this.$refs.grade_form.validate()) {
        return;
      }
      // 等級チェック
      if (this.grade.value == null || !this.grade.value) {
        this.$refs.dialog.open(
          'info',
          '等級が選択されていません。等級を選択して下さい。'
        );
        return;
      }
      // 着任日チェック
      let localGradeJoinDateEntry = this.gradeJoinDate.replaceAll('-', '/');
      if (!chackDateFormatStr(localGradeJoinDateEntry)) {
        this.$refs.dialog.open(
          'info',
          '着任日が正しい日付ではありません。\n 着任日は西暦で「YYYY-MM-DD」の形式で入力してください。'
        );
        return;
      } else {
        this.gradeJoinDate = this.gradeJoinDate.replaceAll('/', '-');
      }
      // 着任日の日付チェック
      var tmpGradeJoinData = this.gradeJoinDate.replaceAll('-', '');
      if (tmpGradeJoinData < this.latestGradeJoinDate) {
        this.$refs.dialog.open(
          'info',
          '着任日が現在に有効な等級着任日より過去日が入力されています。\n 着任日は有効な[' +
            makeDateFormatStr(this.latestGradeJoinDate, '/', '/', '') +
            ']と同じか、未来の日付を入力してください。'
        );
        return;
      }
      // 確認ダイアログ表示
      this.deleteFlg = false;
      this.confirmMessage =
        '[' + this.grade.label + ']のスタッフ等級情報を登録しますか？';
      this.$refs.confirm.open();
    },
    editUserGradeInfo() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      if (this.deleteFlg) {
        // 削除処理
        this.deleteUserGradeInfoRequest();
      } else {
        // 登録処理
        this.editUserGradeInfoRequest();
      }
    },
    editUserGradeInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // ユーザ情報作成
      if (this.entryFlg) {
        // 新規登録
        this.userGradeId =
          userInfo.ORGANIZATION_KEY + moment().format('YYYYMMDDHHmmss');
        this.createdAt = moment().format('YYYYMMDDHHmmss');
      }

      let gradeJoinDateEntry = this.gradeJoinDate.replaceAll('-', '');
      let gradeLeaveDateEntry = config.INIT_DATE_VAL;

      if (this.gradeLeaveDate != null && this.gradeLeaveDate.trim()) {
        gradeLeaveDateEntry = this.gradeLeaveDate.replaceAll('-', '');
      }

      // 共通
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- 等級情報登録リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/usergrade/entry',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            USER_ID: this.userId,
            GRADE_ID: this.grade.value,
            ORGANIZATION_KEY: userInfo.ORGANIZATION_KEY,
            GRADE_JOIN_DATE: gradeJoinDateEntry,
            GRADE_LEAVE_DATE: gradeLeaveDateEntry,
            GRADE_VALID_FLG: this.gradeValidFlg,
            CREATED_AT: this.createdAt,
            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr = message.MSG_INFO_USERGRADE_ENTRY_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.dialog = false;
    },

    async regist() {
      this.dialog = false;
    },
  },
};
</script>
